export const handleSubmit = ({ updateAsset, history, assetToEdit, currentCustomerId }) => values => {
  const updatedData = updateAsset({
    variables: {
      assetInput: {
        ...values,
        categories: undefined,
      },
      assetId: assetToEdit.id,
      customerId: currentCustomerId,
    },
  });

  return updatedData.then(result => {
    const asset = result.data.updateAsset;
    if (asset) {
      history.goBack()
    }
  });
};
